import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import Logo from '../../../../Styles/imagenes/Logo Maquinaria.jpg';
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { Font } from '@react-pdf/renderer';
import MyCustomFont from "./fonts/Roboto-Bold.ttf";

Font.register({
    family: 'RobotoFamily',
    src: MyCustomFont
})

// Estilos personalizados
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#ffffff',
    },
    titulo: {
        backgroundColor: '#477c2c',
        height: 57,
        marginTop: 51,
        textAlign: 'center',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tituloTexto: {
        fontSize: 20,
        marginLeft: 40,
        fontFamily: 'RobotoFamily'
    },
    imagenContainer: {
        position: 'absolute',
        top: 0,
        left: 30,
    },
    logoImagen: {
        width: 150,
    },
    table: {
        marginTop: 60,
        marginLeft: 30,
        marginRight: 30,
        display: 'table',
        width: 'auto',
        borderRadius: 5,
        borderWidth: 1,

    },
    tableRow: {
        flexDirection: 'row',
        marginTop: 5,
        borderBottomWidth: 1,
        borderColor: '#afb69d'
    },
    tableRowTitulo: {
        flexDirection: 'row',
        borderBottomWidth: 3,
        borderColor: '#fedb05',
        backgroundColor: '#275027',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        height: 30

    },
    tableCol: {
        width: '80',

    },
    tableColVencido: {
        width: '150',

    },
    tableColidSucursal: {
        width: '30',
    },
    tableColPorcentaje: {
        width: '50',
    },
    tableCell: {
        marginRight: 5,
        textAlign: 'right',
        fontSize: 8,
        height: 20,

    },
    tableCellTitulo: {
        fontSize: 8,

        borderLeftWidth: 2,
        borderColor: '#fedb05',
        textAlign: 'center',
        marginTop: '5%',
        marginBottom: '5%',
    },
    tableCellPorcentaje: {
        fontSize: 8,
        textAlign: 'center',
        marginTop: '5%',
        marginBottom: '5%'
    },
    tableCellSucursal: {
        marginLeft: 10,
        textAlign: 'left',
        fontSize: 8,
        height: 20,

    },
    tituloFila: {
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',

    },
    textoTituloFila: {
        fontFamily: 'RobotoFamily'
    },

});


const TotalCateraPorSucursalPDF = ({ data }) => (
    <Document>
        <Page size="LETTER" orientation="landscape" style={styles.page} >
            <View style={styles.titulo}>
                <Text style={styles.tituloTexto}>RESUMEN DE CARTERA POR SUCURSAL</Text>
            </View>
            <View style={styles.imagenContainer}>
                <Image src={Logo} style={styles.logoImagen} />
            </View>

            <View style={styles.table}>
                <View style={{ ...styles.tableRowTitulo, ...styles.tituloFila }}>
                    <View style={styles.tableColidSucursal}>
                        <Text style={{ ...styles.tableCellPorcentaje, ...styles.textoTituloFila }}>#</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>SUCURSAL</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>TOTAL CARTERA</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>SALDO A FAVOR</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>TOTAL</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>JURIDICO</Text>
                    </View>
                    <View style={styles.tableColidSucursal}>
                        <Text style={{ ...styles.tableCellPorcentaje, ...styles.textoTituloFila }}>%</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>CARTERA ACTIVA</Text>
                    </View>
                    <View style={styles.tableColidSucursal}>
                        <Text style={{ ...styles.tableCellPorcentaje, ...styles.textoTituloFila }}>%</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>POR VENCER</Text>
                    </View>
                    <View style={styles.tableColidSucursal}>
                        <Text style={{ ...styles.tableCellPorcentaje, ...styles.textoTituloFila }}>%</Text>
                    </View>
                    <View style={styles.tableCol}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>VENCIDA</Text>
                    </View>
                    <View style={styles.tableColidSucursal}>
                        <Text style={{ ...styles.tableCellPorcentaje, ...styles.textoTituloFila }}>%</Text>
                    </View>
                </View>
                {data.map((x, index) => (
                    <View
                        style={
                            index === data.length - 1
                                ? {flexDirection: 'row', marginTop: 5, fontFamily: 'RobotoFamily'}
                                : styles.tableRow
                        }
                        key={index}
                    >
                        <View style={styles.tableColidSucursal}>
                            <Text style={styles.tableCell}>{x.idsucursal}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCellSucursal}>{x.sucursal}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{FormatMoney(x.totalcartera + x.juridico)}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCell, color: 'red' }}>{FormatMoney(x.saldoafavor)}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{FormatMoney(x.total + x.juridico)}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{FormatMoney(x.juridico)}</Text>
                        </View>
                        <View style={styles.tableColidSucursal}>
                            <Text style={styles.tableCell}>{FormatMoney((x.juridico / (x.totalcartera + x.juridico)) * 100)}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{FormatMoney(x.activo)}</Text>
                        </View>
                        <View style={styles.tableColidSucursal}>
                            <Text style={styles.tableCell}>{FormatMoney((x.activo / (x.totalcartera + x.juridico)) * 100)}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{FormatMoney(x.porvencer)}</Text>
                        </View>
                        <View style={styles.tableColidSucursal}>
                            <Text style={styles.tableCell}>{FormatMoney((x.porvencer / (x.totalcartera + x.juridico)) * 100)}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{FormatMoney(x.vencido)}</Text>
                        </View>
                        <View style={styles.tableColidSucursal}>
                            <Text style={styles.tableCell}>{FormatMoney((x.vencido / (x.totalcartera + x.juridico)) * 100)}</Text>
                        </View>
                    </View>
                ))}
            </View>
        </Page>
        <Page size="LETTER" orientation="landscape" style={styles.page}>
            <View style={styles.titulo}>
                <Text style={styles.tituloTexto}>RESUMEN DE CARTERA POR SUCURSAL VENCIDO</Text>
            </View>
            <View style={styles.imagenContainer}>
                <Image src={Logo} style={styles.logoImagen} />
            </View>
            <View style={styles.table}>
                <View style={{ ...styles.tableRowTitulo, ...styles.tituloFila }}>
                    <View style={styles.tableColidSucursal}>
                        <Text style={{ ...styles.tableCellPorcentaje, ...styles.textoTituloFila }}>#</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>SUCURSAL</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>VENCIDO</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>DE 1 A 15</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>MAS DE 15</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>MAS DE 30</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>MAS DE 60</Text>
                    </View>
                    <View style={styles.tableColVencido}>
                        <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>MAS DE 90</Text>
                    </View>
                </View>
                {data.map((x, index) => (
                    <View
                        style={
                            index === data.length - 1
                                ? {flexDirection: 'row', marginTop: 5, fontFamily: 'RobotoFamily'}
                                : styles.tableRow
                        }
                        key={index}
                    >
                        <View style={styles.tableColidSucursal}>
                            <Text style={styles.tableCell}>{x.idsucursal}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCellSucursal}>{x.sucursal}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCell}>{FormatMoney(x.vencido)}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCell}>{FormatMoney(x.de1a15)}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCell}>{FormatMoney(x.mas15)}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCell}>{FormatMoney(x.mas30)}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCell}>{FormatMoney(x.mas60)}</Text>
                        </View>
                        <View style={styles.tableColVencido}>
                            <Text style={styles.tableCell}>{FormatMoney(x.mas90)}</Text>
                        </View>
                    </View>
                ))}
            </View>
        </Page>
    </Document>
);

export default TotalCateraPorSucursalPDF;
